import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {AsyncState, RejectedState} from '../../models/async_state';
import {Status} from '../../enums/status';
import {Auth} from '../../network/auth';

interface State {
    succeeded: boolean;
    isRestore: boolean;
}

export const requestEmailLink = createAsyncThunk('authWithEmail/requestEmailLink', async (email: string) => {
    const result = await Auth.requestEmailLink(email);
    return result.data;
});

export const authWithEmailSlice = createSlice({
    name: 'authWithEmail',
    initialState: () => {
        const initialState: AsyncState<State> = {
            status: Status.IDLE,
            succeeded: false,
            isRestore: false,
        };
        return initialState as AsyncState<State>;
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(requestEmailLink.pending, (state) => {
            state.status = Status.PENDING;
        });
        builder.addCase(requestEmailLink.fulfilled, (state, action) => {
            state.status = Status.FULFILLED;
            state.succeeded = true;
            state.isRestore = action.payload?.customerRestore === true;
        });
        builder.addCase(requestEmailLink.rejected, (state, action) => {
            state.status = Status.REJECTED;
            (state as RejectedState<State>).error = action.error.message ?? 'Error';
        });
    },
});
